import { Link } from 'react-router-dom';
import { Card, Notice, RuledPage } from '@kollez/design-system';

/**
 * Placeholder — the email-verification flow POSTs from a clicked link at /verify-email/:token.
 * For MVP we just confirm the account is created; email delivery is stubbed until MSG91 / Azure
 * Communication is wired.
 */
export function VerifyEmailPage() {
  return (
    <RuledPage>
      <section className="max-w-page-narrow mx-auto px-6 py-16">
        <p className="eyebrow">One more step</p>
        <h1 className="font-serif text-4xl mb-6">Check your email</h1>
        <Card padding="lg" className="max-w-md">
          <Notice tone="info" className="mb-4">
            We sent a verification link to your inbox. Click it to confirm your email — it expires
            in 24 hours.
          </Notice>
          <p className="text-sm text-ink-secondary">
            Didn't get it? Check spam, or <button className="link" type="button">resend</button>.
          </p>
          <p className="mt-6 text-sm text-ink-secondary">
            Wrong email? <Link to="/register/student" className="link">Start over</Link>.
          </p>
        </Card>
      </section>
    </RuledPage>
  );
}
